import React from 'react'
import { Formik } from 'formik'
import PropTypes from 'prop-types'
import EditUsersForm from './EditUserForm'

class UserDetailForm extends React.Component {
  handleSubmit = (values, { setSubmitting }) => {
    const { onSubmit, initialValues, onSubmitSuccess } = this.props
    onSubmit(values)
      .then(() => Promise.resolve(setSubmitting(false)))
      .catch(() => setSubmitting(false))
      .then(() => onSubmitSuccess())
  };

  handleReset = () => {
    this.props.onReset()
  }

  _getDefaultUserForm = (formikProps) => {
    return (
      (<EditUsersForm {...this.props} form={formikProps} />)
    )
  }
  render () {
    const { initialValues, FormComponent = this._getDefaultUserForm } = this.props
    return (
      <Formik
        enableReinitialize
        initialValues={initialValues}
        onSubmit={this.handleSubmit}
        onReset={this.handleReset}
        render={(FormComponent)}
      />
    )
  }
}

UserDetailForm.propTypes = {
  initialValues: PropTypes.object,
  FormComponent: PropTypes.func,
  onReset: PropTypes.func,
  onSubmit: PropTypes.func,
  onSubmitSuccess: PropTypes.func
}

UserDetailForm.defaultProps = {
  onReset: () => null,
  onSubmitSuccess: () => null
}

export default UserDetailForm
